<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Edit Loyalty Program</h1>
    </div>

    <div class="container admin-users">
      <h1 class="text-center text-uppercase">{{program.name}}</h1>
      <br>

      <div class="users-list" v-if="!currentUser">
        <div class="no-users" v-if="users.length === 0">There are no unapproved users</div>
        <div
          class="blue-outline-nh"
          v-for="(user) in users" :key="user._id"
        >
          <div class="row">
            <div class="col-sm-4">{{ user.name }}</div>
            <div class="col-sm-4"><a href="" class="admin-clickable" @click.prevent="goUserDetails(user)"><strong>View</strong></a></div>
            <div class="col-sm-4 text-right">
              <a href="" class="admin-clickable" @click.prevent="approve(user.userLoyaltyProgram._id)">
                <strong>Approve</strong>
              </a> |
              <a href="" class="admin-clickable" @click.prevent="deny(user._id)"><strong>Deny</strong></a>
            </div>
          </div>
        </div>
        <br>
        <router-link :to="{name: 'EditLoyaltyProgram'}" class="btn btn-lg admin-btn-primary col-md-2 col-md-offset-10">Back</router-link>
        <div class="clearfix"></div>
        <br>
      </div>

      <div class="user-details" v-else>
        <div class="row">
          <div class="col-sm-12">
            <strong>User</strong>
          </div>
        </div>

        <div class="blue-outline-nh light-grey-type">
          <div class="row">
            <div class="col-sm-12">
              <h4>Standard Fields</h4>
              Name: {{ currentUser.name }}<br>
              Username: {{ currentUser.username }}<br>
              Email: {{ currentUser.email }}<br>
              Address: {{ currentUser.address }}<br>
              City: {{ currentUser.city }}<br>
              State: {{ currentUser.state }}<br>
              Zip: {{ currentUser.zip }}<br>
              <div v-if="program.registrationForm.formItems">
                <h4>Program Specific Fields</h4>
                <span v-for="(formItem, index) in program.registrationForm.formItems" :key="index">
                  {{ formItem.label }}: {{ currentUser.userLoyaltyProgram.completedRegistration[formItem.uid] }}<br>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <a href="" class="admin-clickable" @click.prevent="currentUser = null"><strong>Back</strong></a> |
            <a href="" class="admin-clickable" @click.prevent="approve(currentUser.userLoyaltyProgram._id)">
              <strong>Approve</strong>
            </a> |
            <a href="" class="admin-clickable" @click.prevent="deny(currentUser._id)"><strong>Deny</strong></a>
          </div>
        </div>
        <br><br>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

export default {
  name: 'UnapprovedUsers',
  data () {
    return {
      currentUser: null
    }
  },
  computed: {
    ...mapState('loyaltyProgram', ['program']),
    ...mapState('user', [ 'users' ])
  },
  methods: {
    ...mapActions('user', [
      'updateUserLoyaltyProgram',
      'deleteUserById',
      'removeUser'
    ]),
    approve (id) {
      const user = this.currentUser || this.users.find(user => user.userLoyaltyProgram._id === id)
      this.updateUserLoyaltyProgram({
        id,
        userLoyaltyProgram: { approved: true, approvalDate: Date.now() }
      })
        .then(() => {
          return new Promise((resolve, reject) => {
            axios.post(
              `${process.env.VUE_APP_SERVER_HOST}/api/common/mailer/userApproved`,
              {
                emailInfo: {
                  to: user.email,
                  company: this.program.company ? this.program.company.name : '',
                  slug: this.program.slug
                }
              }
            )
              .then(response => {
                resolve(response)
              })
              .catch(err => {
                reject(err)
              })
          })
        })
        .then(() => {
          // this.$router.push({ name: 'EditLoyaltyProgram' })
          this.removeUser(user._id)
          if (this.currentUser) this.currentUser = null
        })
        .catch(err => {
          console.log(err)
        })
    },
    deny (id) {
      const user = this.currentUser || this.users.find(user => user.userLoyaltyProgram._id === id)
      this.deleteUserById(id)
        .then(() => {
          if (this.currentUser) this.currentUser = null
        })
        .catch(err => {
          console.log(err)
        })
    },
    goUserDetails (user) {
      this.currentUser = user
    }
  }
}
</script>
